export default {
    "DeFi Binance": "DeFi Binance",
    "流动性挖矿": "تعدين السيولة",
    "加入节点， 开始挖矿": "انضم للعقدة وابدأ التعدين",
    "参 与": "شارك",
    "矿池数据": "بيانات الحوض",
    "总产量": "إجمالي الإنتاج",
    "有效节点": "العُقد النشطة",
    "参与者": "المشاركون",
    "用户收入": "دخل المستخدم",
    "挖矿榜单": "قائمة التعدين",
    "流动性挖矿收入": "دخل تعدين السيولة",
    "输出记录": "سجلات الإنتاج",
    "地址": "العنوان",
    "数量": "الكمية",
    "帮助中心": "مركز المساعدة",
    "希望它可以帮助你": "نأمل أن يساعدك",
    "安全保障": "الأمان",
    "我们有安全的审计报告": "لدينا تقارير تدقيق أمني",
    "伙伴": "الشركاء",
    "我们的商业伙伴": "شركاؤنا التجاريون",
    "首页": "الرئيسية",
    "我的矿池": "حوضي",
    "提取": "سحب",
    "账户": "الحساب",
    "总挖矿金额": "إجمالي المبلغ المُعدّن",
    "可更换": "قابل للتبديل",
    "收益率": "العائد",
    "币池名称": "اسم الحوض",
    "最低金额": "الحد الأدنى",
    "收益率/24小时": "عائد/24 ساعة",
    "挖矿记录": "سجلات التعدين",
    "金额": "المبلغ",
    "描述": "الوصف",
    "时间": "الوقت",
    "已参与": "مشارك",
    "质 押": "رهن",
    "已质押": "مرهون",
    "记录": "سجل",
    "兑换": "تحويل",
    "从": "من",
    "全部": "الكل",
    "至": "إلى",
    "价格": "السعر",
    "确认": "تأكيد",
    "矿池收益": "أرباح الحوض",
    "今日收益": "أرباح اليوم",
    "普通矿池": "الحوض العادي",
    "高级矿池": "الحوض المتقدم",
    "全部的": "الكل",
    "可用的": "متاح",
    "申请加入": "قدم طلبًا للانضمام",
    "推荐朋友": "أوصِ الأصدقاء",
    "一起赚取加密货币": "اكسب العملات معًا",
    "查看详情": "عرض التفاصيل",
    "团队": "الفريق",
    "推荐": "إحالة",
    "团队规模": "حجم الفريق",
    "直接发起人": "الراعي المباشر",
    "总收入": "إجمالي الدخل",
    "今天的收入": "دخل اليوم",
    "我的推荐链接": "رابط الإحالة الخاص بي",
    "复制": "نسخ",
    "1. 获取链接": "1. احصل على الرابط",
    "2. 邀请朋友": "2. ادعُ الأصدقاء",
    "3. 赚取加密货币": "3. اكسب العملات",
    "等级": "المستوى",
    "1 级": "المستوى 1",
    "2 级": "المستوى 2",
    "3 级": "المستوى 3",
    "用户地址": "عنوان المستخدم",
    "币种": "العملة",
    "说明": "التفاصيل",
    "状态": "الحالة",
    "定时收益": "أرباح منتظمة",
    "今日预收益": "الأرباح المتوقعة اليوم",
    "累计收益": "الأرباح الإجمالية",
    "将矿池收益的BNB兑换成USDT后立即到账": "تحويل أرباح الحوض إلى USDT فورًا",
    "将USDT提取后会在24小时内到达你的钱包": "سيصل السحب إلى محفظتك خلال 24 ساعة",
    "天": "أيام",
    "高级矿池收益": "أرباح الحوض المتقدم",
    "质押收益": "أرباح الرهن",
    "下次收益": "الأرباح القادمة",
    "当前收益率": "معدل العائد الحالي",
    "昨日收益": "أرباح الأمس",
    "普通矿池收益率": "عائد الحوض العادي",
    "高级矿池收益率": "عائد الحوض المتقدم",
    "高级矿池限时开放": "الحوض المتقدم مفتوح لفترة محدودة",
	"公告":"إعلان",
	"我知道了":"أرى"
};
